<template>
	<div class="flex xl12 lg12 md12 mx-auto">
		<vue-pull-refresh :on-refresh="onRefresh" :config="pullConfig">
			<v-card color="transparent" elevation="0">
				<v-card-title class="px-1 pt-0">
					<h1 class="hidden-sm-and-down">Gebruikers</h1>
					<v-spacer class="hidden-sm-and-down"></v-spacer>
					<v-text-field
						label="Zoeken"
						single-line
						hide-details
						prepend-inner-icon="search"
						v-model="search"
						@keyup.enter="performSearch"
						clearable
						@click:clear="clearSearch"
					></v-text-field>
				</v-card-title>
				<v-data-table
					v-model="selected"
					v-bind:headers="headers"
					v-bind:items="items"
					v-bind:pagination.sync="pagination"
					:rows-per-page-items="[25, 50]"
					no-data-text="..."
					:loading="loading"
					item-key="name"
					:total-items="pagination.totalItems"
				>
					<v-progress-linear
						slot="progress"
						color="blue"
						indeterminate
					></v-progress-linear>
					<template slot="headers" slot-scope="props">
						<tr class="hidden-xs-only">
							<th
								v-for="header in props.headers"
								:key="header.text"
								:class="[
									'column sortable text-xs-left',
									pagination.descending ? 'desc' : 'asc',
									header.value === pagination.sortBy ? 'active' : ''
								]"
								@click="changeSort(header.value)"
							>
								{{ header.text }}
								<v-icon>arrow_upward</v-icon>
							</th>
						</tr>
					</template>
					<template slot="items" slot-scope="props">
						<tr @click="showUser(props.item)">
							<td class="hidden-xs-only">{{ props.item.memberNumber }}</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.firstname }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.lastname }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.companyname }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.username }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.phoneno }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ utils.getFormattedDate(props.item.lastRentDate, false) }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.totalRentSum | toCurrency }}
							</td>
							<td class="text-xs-left hidden-xs-only">
								{{ props.item.rentalCheck_status || '-' }}
							</td>
							<!-- Mobile -->
							<td class="text-xs-left hidden-sm-and-up itemRow">
								<h3>
									#{{ props.item.id }} {{ props.item.firstname }}
									{{ props.item.lastname }}
									<template v-if="props.item.companyname">
										- {{ props.item.companyname }}</template
									>
								</h3>
								<template v-if="props.item.totalRentSum"
									>&euro; {{ props.item.totalRentSum | toCurrency }}<br
								/></template>
								Rental check: {{ props.item.rentalCheck_status || '-' }}<br />
								{{ props.item.city }}<br />{{ props.item.phoneno }} <br />{{
									props.item.username
								}}

								<span
									class="other reservationStatus"
									v-if="props.item.active == '1'"
									>Actief</span
								>
							</td>
							<td class="text-xs-left hidden-xs-only">
								<v-icon
									class="left"
									color="green"
									v-if="props.item.active == '1'"
									>checked</v-icon
								>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-card>
		</vue-pull-refresh>
	</div>
</template>
<script>
import * as utils from '@/utils/utils';
import VuePullRefresh from 'vue-pull-refresh';
import { _ } from 'vue-underscore';

export default {
	name: 'UsersTable',
	components: { VuePullRefresh },
	props: ['filters'],
	data() {
		return {
			pullConfig: window.pullConfig,
			dialog: false,
			pagination: {
				sortBy: 'id',
				descending: true,
				page: 1,
				rowsPerPage: 25,
				totalItems: 0
			},
			selected: [],
			search: '',
			utils: utils,
			headers: [
				{
					text: '#',
					align: 'left',
					value: 'id'
				},
				{ text: 'Voornaam', value: 'firstname' },
				{ text: 'Achternaam', value: 'lastname' },
				{ text: 'Bedrijfsnaam', value: 'companyname' },
				{ text: 'E-mail', value: 'username' },
				{ text: 'Tel nr', value: 'phoneno' },
				{ text: 'Laatste huur', value: 'lastRentDate' },
				{ text: 'Totaal', value: 'totalRentSum' },
					{ text: 'Rental check', value: 'rentalCheck_status' },
				{ text: 'Actief', value: 'active' }
			],
			items: [],
			allItems: [],
			loading: true,
			searchTerm: ''
		};
	},
	watch: {
		$route(to, from) {
			this.pagination.page = 1;
			this.showUsers();
		},
		pagination: {
			handler(newPagination) {
				this.showUsers();
			},
			deep: true
		},
		search(val) {
			// Removed automatic search on keystroke - now triggered by Enter key only
		},
		filters: {}
	},
	created: function() {
		this.showUsers();
	},
	methods: {
		showUsers() {
			let self = this;
			this.getUsers().then(function() {
				if (self.$route.params.type) {
					self.items = _.filter(self.allItems, { active: '0' });
				}
			});
		},
		performSearch() {
			this.searchTerm = this.search;
			// Reset to first page when search changes
			this.pagination.page = 1;
			this.getUsers();
		},
		clearSearch() {
			this.search = '';
			this.searchTerm = '';
			// Reset to first page
			this.pagination.page = 1;
			this.getUsers();
		},
		getUsers() {
			var self = this;
			self.loading = true;
			const page = this.pagination.page;
			const limit = this.pagination.rowsPerPage;
			const offset = (page - 1) * limit;
			
			let url;
			if (this.searchTerm && this.searchTerm.trim() !== '') {
				// Use search endpoint when searching
				url = `${basePath}api/users/search?query=${encodeURIComponent(this.searchTerm)}&page=${page}&limit=${limit}&offset=${offset}`;
			} else {
				// Use regular endpoint for all users
				url = `${basePath}api/users/?page=${page}&limit=${limit}&offset=${offset}`;
			}
			
			return utils.getData(url).then(function(json) {
				self.loading = false;
				self.items = json.data;
				// Update total items if provided by API
				if (json.total !== undefined) {
					self.pagination.totalItems = json.total;
				}
			});
		},
		showUser(user) {
			user.edit = true;
			this.$emit('showUser', user);
		},
		toggleAll() {
			if (this.selected.length) this.selected = [];
			else this.selected = this.items.slice();
		},
		changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		onRefresh() {
			const self = this;
			return new Promise(function(resolve, reject) {
				self.getUsers(false).then(function() {
					setTimeout(function() {
						resolve();
					}, 500);
				});
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Users/UsersTable.vue